import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import user from './modules/user'
import appointment from './modules/appointment'
import school from './modules/school'
import chat from './modules/chat'
import tour from './modules/tour'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    appointment,
    school,
    chat,
    tour
  }
})
